import Marquee from "react-fast-marquee";

const WORDS = ["365 DAYS", "₹365", "ONE HEALTHIER YOU", "MIND", "BODY", "GUT", "LIFESTYLE", "ACTIVE360™"];

export const EditorialMarquee = () => {
  return (
    <div className="relative bg-[#020617] border-y border-cyan-500/10 py-6 overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={32} gradient={false}>
        {WORDS.concat(WORDS).map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-extrabold uppercase text-2xl sm:text-4xl text-white/90 px-8">
              {w}
            </span>
            <span className="text-cyan-500/50 text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
